angular.module('wbServices').service 'wbConfig', ['railsResource', ($resource) ->
  WBConfig = $resource('/config').get()

  WBConfig
]
